import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathConnections(connectionId=null) {
  if (connectionId) {
      return `connections/${connectionId}`;
  } else {
      return `connections`;
  }
}

export function deleteConnections(successCallback, errorCallback, connectionId) {
  deleteAuth({
    "path": pathConnections(connectionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postDisconnectConnections(successCallback, errorCallback, connectionId) {
  postAuth({
    "path": `connections/${connectionId}/disconnect`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postResyncConnections(successCallback, errorCallback, connectionId) {
  postAuth({
    "path": `connections/${connectionId}/resync`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postReconnectConnections(successCallback, errorCallback, connectionId) {
  postAuth({
    "path": `connections/${connectionId}/reconnect`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewMarketingPlatformConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/marketing-platform-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
